/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-caret-down': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M14.375 7.5L10 12.5l-4.375-5z"/>'
  }
})
